import {
    AccreditationsSlotId,
    CustomFieldSlug,
    CustomFieldWithConditionFragment
} from '../generated/types';

export type FieldFormElement = {
    isMandatory: boolean;
    customField: CustomFieldWithConditionFragment;
};

export type AccreditationFieldFormElement = FieldFormElement & {
    accreditationsSlotsIds: AccreditationsSlotId[];
};

type SlugToAccreditationFieldFormElement = Record<CustomFieldSlug, AccreditationFieldFormElement>;

export function uniqAccreditationFieldFormElement(
    formElements: AccreditationFieldFormElement[]
): AccreditationFieldFormElement[] {
    return Object.values(
        formElements.reduce(
            (current: SlugToAccreditationFieldFormElement, afcf: AccreditationFieldFormElement) => {
                if (current[afcf.customField.slug]) {
                    const currentValue = current[afcf.customField.slug];

                    return {
                        ...current,
                        [afcf.customField.slug]: {
                            accreditationsSlotsIds: currentValue.accreditationsSlotsIds.concat(
                                afcf.accreditationsSlotsIds
                            ),
                            customField: afcf.customField,
                            isMandatory: currentValue.isMandatory || afcf.isMandatory
                        }
                    };
                } else {
                    return {
                        ...current,
                        [afcf.customField.slug]: {
                            accreditationsSlotsIds: afcf.accreditationsSlotsIds,
                            customField: afcf.customField,
                            isMandatory: afcf.isMandatory
                        }
                    };
                }
            },
            {}
        )
    );
}
